'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_GoogleSyncRequest(from, to) {
  this.Sh = null;
  this.Si = null;
  this.Sh = from;
  this.Si = to;
}
export { $c_Lmealorama_GoogleSyncRequest as $c_Lmealorama_GoogleSyncRequest };
$p = $c_Lmealorama_GoogleSyncRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GoogleSyncRequest;
/** @constructor */
function $h_Lmealorama_GoogleSyncRequest() {
}
export { $h_Lmealorama_GoogleSyncRequest as $h_Lmealorama_GoogleSyncRequest };
$h_Lmealorama_GoogleSyncRequest.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1096985234, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_GoogleSyncRequest)) {
    var x = this.Sh;
    var x$2 = x$0.Sh;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Si;
      var x$4 = x$0.Si;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "GoogleSyncRequest";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sh;
  }
  if ((n === 1)) {
    return this.Si;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_GoogleSyncRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ju)));
}
export { $isArrayOf_Lmealorama_GoogleSyncRequest as $isArrayOf_Lmealorama_GoogleSyncRequest };
var $d_Lmealorama_GoogleSyncRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GoogleSyncRequest, "mealorama.GoogleSyncRequest", ({
  ju: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_GoogleSyncRequest as $d_Lmealorama_GoogleSyncRequest };
//# sourceMappingURL=mealorama.-Google-Sync-Request.js.map
